import React, { useState } from 'react'
import { Button, Checkbox, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box, Stack } from '@mui/system'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import { getQRTransactionColumn, getQRTransactionTableData, getApprAuthority } from '../../constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import { navigation3 } from '../../../../common/helper'
import InfoIcon from '@mui/icons-material/Info'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { userRRQTBookAcSpecialRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import OTPModal from '../OTPModal'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'
const QRTransactionRights = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const QRTransactionColumn = getQRTransactionColumn(translations)
    const QRTransactionTableData = getQRTransactionTableData(translations)
    const ApprAuthority = getApprAuthority(translations)
    const { data, updateModal,userRollRightSendOTP,updateAlertError,userRRQTBookAcSpecialRightsSave, QRTRightsCheckValue, setQRTRightsCheckValue, otpOnUserRights, roleId,loginData } = props
    const { common } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: '5%'
    }
    const [selApprAuth, setSelApprAuth] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
        })
    }


    const saveApi = () => {
        const obj = {
          RoleID: roleId,
          QRUserSelf: QRTRightsCheckValue?.AllowQRUserSelf,
          QRUserOther: QRTRightsCheckValue?.AllowQRUserOther,
          QRUserSameCity: QRTRightsCheckValue?.AllowQRUserSameCity,
          QRBranchSelf: QRTRightsCheckValue?.AllowQRBranchSelf,
          QRBranchOther: QRTRightsCheckValue?.AllowQRBranchOther,
          QRBranchSameCity: QRTRightsCheckValue?.AllowQRBranchSameCity,
          QRCompany: QRTRightsCheckValue?.AllowQRCompany,
          BaseUserID: loginData?.intUserID
        }
        userRRQTBookAcSpecialRightsSave(obj).then((res) => {
          if (res?.status == 'Success') {
            setIsOpen({ ...isOpen, open: true, message: bum.qrTransactionsRightsSavedSuccessfullyNl || "QR Transactions Rights\nSaved Successfully!" })
          } else {
            setSaveError({ ...saveError, error: true, message: res.Message })
          }
        }).catch((err) => {
          setSaveError({ ...saveError, error: true, message: err })
        })
    }
    const onSave = () => {
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: bum.selectApprovalAuthority || "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
    }

    const handleChange = (value, field) => {
        setQRTRightsCheckValue({ ...QRTRightsCheckValue, [field]: value })
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`URR-${index}`}>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#444', fontWeight: "500" }}>{item.Booking}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
                    <Checkbox
                        checked={QRTRightsCheckValue[item.field1] == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        onChange={(e) => handleChange(e.target?.checked ? 1 : 0, item.field1)}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
                    <Checkbox
                        checked={QRTRightsCheckValue[item.field2] == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        onChange={(e) => handleChange(e.target?.checked ? 1 : 0, item.field2)}
                    />
                </TableCell>
                {
                    index == 0 ?
                        <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#444' }}>
                            <Checkbox
                                checked={QRTRightsCheckValue[item.field3] == 1}
                                sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                                onChange={(e) => handleChange(e.target?.checked ? 1 : 0, item.field3)}
                            />
                        </TableCell> : <TableCell></TableCell>
                }
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={{ padding: "16px", paddingBottom: "5px" }}>
                <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '65vh', maxWidth: "450px", marginBottom: "5px" }} >
                    <Table stickyHeader size="small" aria-label="a dense table" sx={{
                        '& .MuiTableCell-root': {
                            padding: '6px !important',
                        }
                    }}>
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                            <TableRow>
                                {QRTransactionColumn.map((col, index) =>
                                    <TableCell key={`TH-${index}`} style={{ ...col.headerSx, textAlign: index == 0 ? "" : "center", backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {QRTransactionTableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Stack className="itemButtons beachTransBottomSec">
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "5px", gap: "12px" }}>
                    <Box style={{ display: "flex" }}>
                        <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                            <DropDownOA
                                id={"UmAppAuth"}
                                data={ApprAuthority || []}
                                defaultvalue={selApprAuth?.name || ''}
                                width="100%"
                                searchPlaceholder={bum.searchBranchName || 'Search Branch Name'}
                                label={bum.approvalAuthority || "Approval Authority"}
                                dataKey={`name`}
                                idKey={`id`}
                                nextId={"UMActive"}
                                field={'compulsory'}
                                prevId={"UMPAN"}
                                onSelect={(value) => setSelApprAuth(value)}
                                direction='up'
                            />
                        </Item>
                        <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                            <InfoIcon style={{ color: "#0086FF" }} />
                            <span style={{ color: "#1E59A7" }}>{bum.otpWillSendToManagementAsPerSelection || 'OTP will send to the Management as per Selection'}</span>
                        </Box>
                    </Box>
                    <Box style={{ display: "flex", gap: "15px" }}>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMSave", "UMUserStatus", () => { })}>
                            <Button id={"UMCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => updateModal(false, "BookAccSpecialRights")}>
                                {bum.cancel || 'CANCEL'}
                            </Button>
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMUserName", "UMCancel", () => { })}>
                            <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                            onClick={() => onSave()}
                            >
                                {bum.save || 'Save'}
                            </Button>
                        </Item>
                    </Box>
                </Box>
                {/* */}
            </Stack>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal,updateAlertError,userRRQTBookAcSpecialRightsSave
}

export default connect(mapStateToProps, mapDispatchToProps)(QRTransactionRights)